<div class="content-container mb-3">
    <div class="title d-inline-flex w-100">
        Message Container
    </div>
    <div class="content d-flex flex-wrap">
        <div class="row w-100">
            <div class="col-4 mb-3">
                <div class="message-container">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Standard With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container">
                    Standard No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container">
                    Standard No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container blue-fill">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Standard Fill With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container blue-fill">
                    Standard Fill No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container blue-fill">
                    Standard Fill No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
        </div>


        <div class="row w-100">
            <div class="col-4 mb-3">
                <div class="message-container green">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Success With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container green">
                    Success No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container green">
                    Success No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container green-fill">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Success With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container green-fill">
                    Success No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container green-fill">
                    Success No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-4 mb-3">
                <div class="message-container red">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Error With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container red">
                    Error No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container red">
                    Error No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container red-fill">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Error Fill With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container red-fill">
                    Error Fill No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container red-fill">
                    Error Fill No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
        </div>

        <div class="row w-100">
            <div class="col-4 mb-3">
                <div class="message-container warning">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Warning With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container warning">
                    Warning No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container warning">
                    Warning No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container warning-fill">
                    <div class="header">
                        Header
                    </div>
                    <div>
                        Warning Fill With Header
                    </div>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container warning-fill">
                    Warning Fill No Header
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-container warning-fill">
                    Warning Fill No Header
                    <div class="message-box">
                        Message Box
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content-container">
    <div class="title d-inline-flex w-100">
        Message Card
    </div>
    <div class="content d-flex flex-wrap">
        <div class="row w-100">
            <div class="col-4 mb-3">
                <div class="message-card">
                    Standard Card
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-card red">
                    Error Card
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-card green">
                    Sucess Card
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="message-card orange">
                    Warning Card
                </div>
            </div>
        </div>
    </div>
</div>
    